<template>
  <div class="custom-progress" :style="{ width: width + 'px' }">
    <vue-highcharts
      type="chart"
      :options="options"
      :redrawOnUpdate="true"
      :oneToOneUpdate="false"
      :animateOnUpdate="true"
    />
  </div>
</template>
<script>
import VueHighcharts from 'vue3-highcharts'
export default {
  name: 'training-progress',
  components: {
    VueHighcharts,
  },
  props: {
    progress: {
      type: [Number, String],
      default: 0,
    },
    width: {
      type: Number,
      default: 140,
    },
  },
  computed: {
    options() {
      let _options = {
        chart: {
          inverted: true,
          type: 'bullet',
          height: 34,
          width: this.width,
          backgroundColor: 'transparent',
          marginTop: 5,
          spacing: [0, 0, 0, 0],
        },
        title: {
          text: null,
        },
        legend: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories: [''],
        },
        yAxis: {
          gridLineWidth: 0,
          min: 0,
          max: 200,
          labels: {
            enabled: false,
          },
          plotBands: [
            {
              from: 0,
              to: 200,
              color: {
                linearGradient: { x1: 0, x2: 1, y1: 0, y2: 0 },
                stops: [
                  [0, '#fff800'], // start
                  [0.5, '#00bf1c'], // middle 00bf1c 008e15
                  [1, '#ff1e1e'], // end
                ],
              },
            },
          ],
          title: null,
        },
        plotOptions: {
          series: {
            pointPadding: 0.25,
            borderWidth: 0,
            color: '#000',
            targetOptions: {
              width: '200%',
            },
          },
        },
        exporting: {
          enabled: false,
        },
        series: [
          {
            data: [
              {
                y: 0,
                target:
                  parseFloat(this.progress) > 200
                    ? 200
                    : parseFloat(this.progress),
              },
            ],
          },
        ],
      }
      return _options
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-progress {
  height: auto;
  width: auto;
  text-align: center;
  margin: 0 auto;
}
</style>
